import React from "react";
import { ChapterColor } from "../../api/cocApi";
import styles from "./CompactNav.module.less";

export interface Props {
    items: { title: string; onClick?: () => void; background: ChapterColor  }[];
}

export default function CompactNav(props: Props) {
    return (
        <nav className={styles.CompactNav}>
            <ul className={styles["CompactNav-ul"]}>
                {props.items.map(item => (
                    <li className={styles["CompactNav-li"]} key={item.title}>
                        <button className={`${styles["CompactNav-btn"]} ${styles[`CompactNav-btn--${item.background}` as keyof typeof styles]}`} onClick={item.onClick}>{item.title}</button>
                    </li>
                ))}
            </ul>
        </nav>
    );
}
